module.exports = __webpack_public_path__ + "img/pfizer-small.c1527c59.png";